import { QrCodesApi } from '../../api';
import axios from '../axios';

const qrCodeApi = new QrCodesApi(undefined, undefined, axios);

export default qrCodeApi;
